// ============================================================
// FILE:
// frontend/src/ipe/pms/services/siteStoreDashboardService.js
// ============================================================

import axiosClient from "../../../api/axiosClient";
//import axiosClient from "../../../api/axiosClient";



// ============================================================
// GET DASHBOARD SUMMARY
// ============================================================

export const getSiteStoreDashboardSummary = async (
    payload
) => {

    const response = await axiosClient.post(

        "/api/pms/site-store-dashboard/summary",

        payload
    );

    return response.data;
};


// ============================================================
// GET INVENTORY GRID
// ============================================================

export const getSiteStoreInventoryGrid = async (
    payload
) => {

    const response = await axiosClient.post(

        "/api/pms/site-store-dashboard/inventory-grid",

        payload
    );

    return response.data;
};